/**
 * Roles and permissions.
 *
 * Note the split from tenancyService: people are added to an organization
 * through tenancy's member endpoints, because that service owns membership.
 * IAM owns the role catalog, which is what these endpoints manage.
 */
import { api } from '../lib/apiClient.js';

/** The permission catalog. Static per deployment, so it is safe to cache. */
export const listPermissions = () => api.get('/iam/permissions', { skipTenant: true });

/** System roles plus this organization's own custom roles. */
export const listRoles = (options = {}) =>
  api.get('/iam/roles', { query: { includePermissions: options.includePermissions ?? 'true' } });

export const getRole = (roleId) => api.get(`/iam/roles/${roleId}`);

export const createRole = (payload) => api.post('/iam/roles', payload);

export const updateRole = (roleId, payload) => api.put(`/iam/roles/${roleId}`, payload);

export const changeRolePermissions = (roleId, payload) => api.patch(`/iam/roles/${roleId}/permissions`, payload);

export const deleteRole = (roleId) => api.delete(`/iam/roles/${roleId}`);

export const myPermissions = () => api.get('/iam/roles/my-permissions');
